import { render } from "./ShipTrackFooter.vue?vue&type=template&id=4fc98366&scoped=true"
import script from "./ShipTrackFooter.vue?vue&type=script&lang=js"
export * from "./ShipTrackFooter.vue?vue&type=script&lang=js"

import "./ShipTrackFooter.vue?vue&type=style&index=0&id=4fc98366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc98366"]])

export default __exports__